export const odluka_blag_maks = {
    templateId: 112,
    category: 4,
    templateTitle: 'Odluka o blagajničkom maksimumu',
    templateDescription: `<p>Svaki poslovni subjekt, čak i onaj koji nema fiskalnu blagajnu i ne prima gotovinu kao sredstvo plaćanja (ne izdaje fiskalizirane račune kod plaćanja gotovinom), u pravilu je obveznik fiskalizacije te je dužan osim odluke o fiskalizaciji, utvrditi visinu blagajničkog maksimumu.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>

    <p>Obveznik fiskalizacije (osim koji na računima u banci ima evidentirane neizvršene obveze za plaćanje), može zadržati gotov novac u blagajni na kraju radnog dana do visine blagajničkog maksimuma.</p>
    <p>Blagajnički maksimum određuje se za obveznike fiskalizacije kao cjelinu, a u okviru toga iznosa obveznik fiskalizacije može odrediti blagajnički maksimum svojim organizacijskim dijelovima.</p>
    <p><strong>Ministar financija propisuje pravilnikom visinu iznosa blagajničkog maksimuma, prema kategorijama poreznih obveznika, no i dalje poduzetnik ima obvezu odrediti visinu blagajničkog maksimumu u vlastitom poslovanju.</strong></p>
    <p>Obveznikom fiskalizacije smatra se:</p>
    <p>1. fizička osoba obveznik poreza na dohodak po osnovi samostalne djelatnosti prema odredbama zakona kojim se uređuje porez na dohodak te</p>
    <p>2. pravna i fizička osoba koja se smatra obveznikom poreza na dobit prema zakonu kojim se uređuje porez na dobit za sve djelatnosti za koje je, prema odredbama posebnih propisa, obveznik izdavanja računa za isporuku dobra ili obavljene usluge.</p>
    
    <p><strong>Dakle, svi poduzetnici su obveznici fiskalizacije, osim poslovnih subjekata koji obavljaju sljedeće djelatnosti: </strong></p>
    <p>1. prodaja karata ili žetona za cestovni lokalni linijski prijevoz putnika u javnom prometu sukladno odlukama jedinica lokalne samouprave te prodaja karata ili žetona u zračnom, željezničkom i linijskom obalnom pomorskom prometu,</p>
    <p>2. naplata cestarine,</p>
    <p>3. punjenje naftnim derivatima aviona na avioservisima,</p>
    <p>4. prodaja vlastitih poljoprivrednih proizvoda na tržnicama i otvorenim prostorima,</p>
    <p>5. prodaja proizvoda i/ili usluga u poštanskom prometu,</p>
    <p>6. zaprimanje uplata za sudjelovanje u igrama na sreću i zabavnim igrama,</p>
    <p>7. prodaja robe ili usluga putem prodajnih automata,</p>
    <p>8. pružanje bankovnih usluga i usluga osiguranja,</p>
    <p>9. vođenja središnjeg depozitorija nematerijaliziranih vrijednosnih papira i središnjeg registra financijskih instrumenata,</p>
    <p>10. ostvareni prometi evidentirani preko mjernih instrumenata (električna energija, plin, voda, javne komunikacijske usluge i slično), od energetskih, komunalnih, elektroničkih komunikacija i drugih pravnih osoba,</p>
    <p>11. provođenja zdravstvene zaštite (sudjelovanje u troškovima zdravstvene zaštite do pune cijene zdravstvene usluge, kod izabranog doktora primarne zdravstvene zaštite i izdavanja lijekova na recept).</p>
    
    <p>Obveznici fiskalizacije imaju sljedeće obveze:</p>
    <li> uskladiti sadržaj računa sa Zakonom o fiskalizaciji u prometu gotovinom</li>
    <li> na svakom elektroničkom naplatnom uređaju ili drugom vidnom mjestu istaknuti obavijest o obvezi izdavanja računa te obvezi kupca da preuzme i zadrži izdani račun.</li>
    <li> internim aktom propisati pravila slijednosti numeričkih brojeva računa, popis poslovnih prostora te dodijeljene oznake poslovnih prostora. </li>
    <li><strong>Internim aktom odrediti visinu  blagajničkog maksimuma.</strong></li>
    <br> 
    <p>Visinu blagajničkog maksimuma određuje obveznik fiskalizacije samostalno internim aktom, sukladno potrebama i uvjetima sigurnosti, no prema sljedećim kriterijima veličine:</p>
    <li> mikro subjekt i fizičke osobe - 10.000,00 kuna,</li>
    <li> mali subjekt - 50.000,00 kuna,</li>
    <li> srednji subjekt - 80.000,00 kuna. </li>
    <li> obveznici fiskalizacije koji prelaze mjerila koja određuju malo gospodarstvo (i poslovni subjekti koji obavljaju mjenjačke poslove) prema zakonu kojim se uređuje razvoj malog gospodarstva - 100.000,00 kuna.</li>
    <br> 
     

    <p><strong>Subjekti koji provode dodatno i fiskalizaciju izdavanja (ključna razlikovna riječ: "izdavanje") računa, kod izdavanja računa koji se naplaćuju u gotovini imaju i dodatne obveze: preuzeti i koristiti digitalni certifikat za postupak fiskalizacije, izdavati račune koji sadrže Jedinstveni identifikator računa, dužan koristiti adekvatno programsko rješenje, dostaviti podatak o prostorima u kojima obavlja djelatnost, itd..</strong></p>

    <h5>NAJČEŠĆE GREŠKE</h5>
    <p><strong>- Neuplaćivanje iznosa koji prelazi visinu blagajničkom maksimuma na račun poslovnog subjekta kod banke </strong></p>
    <p>Pojašnjenje: nepolaganje iznosa gotovine protivno Zakonu o fiskalizaciji u prometu gotovinom predstavlja prekršaj.</p>
   
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o fiskalizaciji u prometu gotovinom, Pravilnik o fiskalizaciji gotovinom. Zakon o poticanju razvoja malog gospodarstva.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o fiskalizaciji u prometu gotovinom,',
            signature: 'Za Obveznika fiskalizacije:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Obveznik fiskalizacije),',
        }
    ],

    headline: '​donosi sljedeću',
    title: 'ODLUKU O BLAGAJNIČKOM MAKSIMUMU',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Ovom Odlukom, sukladno Zakonu o fiskalizaciji u prometu gotovinom, Obveznik fiskalizacije određuje visinu blagajničkog maksimuma.',
                    value: '',
                },
            ],
            value: '',
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Obveznik fiskalizacije kategorizira se kao mikro subjekt malog gospodarstva te sukladno tome određuje blagajnički maksimum od'},
                                {type: 'input', value: '', required: true, },
                                { help: 'Upišite iznos blagajničkog maksimuma - za mikro subjekt i fizičke osobe je najveći iznos 10.000,00 kuna'},
                            ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Obveznik fiskalizacije kategorizira se kao mali subjekt malog gospodarstva te sukladno tome određuje blagajnički maksimum od'},
                                {type: 'input', value: '', required: true},
                                {help: 'Upišite iznos blagajničkog maksimuma - za mali subjekt (te fizičke osobe obveznike poreza na dobit koji ispunjavaju uvjete) je najveći iznos 50.000,00 kuna'},
                            ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Obveznik fiskalizacije kategorizira se kao srednji subjekt malog gospodarstva te sukladno tome određuje blagajnički maksimum od'},
                                {type: 'input', value: '', required: true,},
                                {help: 'Upišite iznos blagajničkog maksimuma - za srednji subjekt (te fizičke osobe obveznike poreza na dobit koji ispunjavaju uvjete) je najveći iznos 80.000,00 kuna'},
                            ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Obveznik fiskalizacije prelazi mjerila koja određuju malo gospodarstvo prema Zakonu o poticanju razvoja malog gospodarstva te sukladno tome određuje blagajnički maksimum od'},
                                {type: 'input', value: '',},
                                {required: true, help: 'Upišite iznos blagajničkog maksimuma - u ovom slučaju je najveći iznos od 100.000,00 kuna'},
                            ]
                        },
                    
                    ],
                    value: '',
                }
            ]
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Obveznik fiskalizacije ne određuje niti dijeli ovom Odlukom određeni iznos blagajničkog maksimuma prema pojedinom poslovnom prostoru, nego ga određuje kao cjelinu.'},
                              
                            ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Obveznik fiskalizacije određuje iznos blagajničkog maksimuma kao cjelinu, ali ga dijeli prema poslovnim prostorima, na sljedeći način:'},
                                {type: 'textarea', value: '', required: true,},
                            ]
                        },
                    ],
                    value: '',
                }
            ]
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Svi zaposlenici Obveznika fiskalizacije odgovorni za blagajničko poslovanje obvezni su pridržavati se odredbi ove Odluke s obzirom na određeni iznos blagajničkog maksimuma.',
                    value: '',
                },
            ],
            value: '',
        }, 
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'Obvezuje se odgovorna osoba (blagajnik) da svotu iznad blagajničkog maksimuma koja je utvrđena na kraju radnog dana položi na račun poslovnog subjekta najkasnije sljedeći radni dan.',
                    value: '',
                },
            ],
            value: '',
        },   
      
          {
            title: "",
            mandatory: true,
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                    { type: "text", content: "Ova Odluka se primjenjuje od dana" }, 
                    { type: "input", value: "", required: true },
                    { type: "text", content: "godine."}, 
                ],
              }
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    parts: [
                        {
                            type: 'text',
                            content: 'U'
                        },
                        {
                            type: 'input',
                            value: '',
                            placeholder: "Upišite mjesto.",                  
                            required: true
                        },
                        {
                            type: 'text',
                            content: ', dana'
                        },
                        {
                            type: 'date',
                            value: new Date(),
                            required: true
                        },
                        {
                            type: 'text',
                            content: 'godine.',
                        }
                    ]
                },
            ]
        },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Poslovni prostor naznačen u odluci \r\n2) Arhiva',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};





// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/112_odluka_blag_maks.ts